import { render, staticRenderFns } from "./RegisterSearchForm.vue?vue&type=template&id=bfc92862&scoped=true&"
import script from "./RegisterSearchForm.vue?vue&type=script&lang=ts&"
export * from "./RegisterSearchForm.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterSearchForm.vue?vue&type=style&index=0&id=bfc92862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc92862",
  null
  
)

export default component.exports